module.exports = __webpack_public_path__ + "Roboto-RegularItalic.527502d7927a41ca0b6a.svg";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-RegularItalic.svg
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-RegularItalic.svg
// module chunks = styles